import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: rgb(250, 250, 250);
  overflow-y: auto;
  width: 100%;
  margin: 48px 0 48px 0;
  padding-right: 10px;
  @media (max-width: 1024px) {
    /* padding: 0 16px; */
    margin-bottom: 200px;
  }
`;
export const WalletContainer = styled.div`
  display: flex;
  /* overflow-x: hidden;
  overflow-y: hidden; */
  align-items: center;
  margin-bottom: 24px;
  width: 100%;
  border-radius: 16px;
  justify-content: space-between;
  @media (max-width: 1024px) {
    flex-direction: column;
    padding: 32px 16px 16px 16px;
    background: var(--bg-white);
    border: 1px solid var(--bg-gray);
    box-shadow: 2px 4px 10px rgba(108, 136, 170, 0.25);
    border-radius: 16px;
    margin-bottom: 24px;
    margin-top: 32px;
  }
`;
export const TableContainer = styled.div`
  background-color: var(--bg-white);
  box-shadow: 2px 4px 10px rgba(108, 136, 170, 0.25);
  border-radius: 16px;
  width: 100%;
  padding: 40px 60px;
  div {
    width: 100%;
  }
  h2 {
    font-size: 18px;
    font-weight: 500;
    color: var(--primary-900);
    direction: rtl;
  }
  @media (max-width: 1875px) {
    padding: 40px 40px;
  }
  @media (max-width: 1536px) {
    padding: 40px 20px;
  }
  @media (max-width: 1024px) {
    box-shadow: none;
    border-radius: 0;
    /* padding: 0 16px; */
    padding: 0;
    background-color: transparent;
    & h2 {
      font-size: 16px;
      font-weight: 700;
    }
  }
`;

export const WalletInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  box-shadow: 2px 4px 10px rgba(108, 136, 170, 0.25);
  border-radius: 16px;
  background-color: var(--bg-white);
  border: 1px solid var(--bg-gray);
  padding: 40px 60px 40px 60px;
  margin-right: 8px;
  height: 100%;
  flex: 1;
  & h2 {
    font-size: 18px;
    font-weight: 500;
    color: var(--primary-900);
    @media (max-width: 1024px) {
      font-size: 16px;
      font-weight: 400;
      color: var(--text-500);
    }
    @media (max-width: 600px) {
      font-size: 14px;
      font-weight: 500;
    }
    @media (max-width: 360px) {
      font-size: 12px;
      font-weight: 400;
    }
  }
  @media (max-width: 1875px) {
    padding: 40px 40px;
  }
  @media (max-width: 1536px) {
    padding: 40px 20px;
  }
  @media (max-width: 1024px) {
    flex: 1;
    width: 100%;
    box-shadow: none;
    border-radius: 0;
    border: none;
    background-color: transparent;
    padding: 0;
    margin-bottom: 24px;
    & .mobileInfo {
      padding: 12px 8px;
      border: 1px solid var(--bg-gray);
      border-radius: 10px;
      width: 100%;
      direction: rtl;
      color: var(--text-500);
      font-size: 16px;
      font-weight: 700;
      margin-top: 4px;
      @media (max-width: 768px) {
        font-size: 14px;
      }
      @media (max-width: 360px) {
        font-size: 12px;
      }
    }
  }
`;

export const UserChargeHeader = styled.h1`
  display: flex;
  justify-content: flex-start;
  color: #27548c;
`;

export const UserInfoContainer = styled.div`
  width: 100%;
  direction: rtl;
  & > div {
    margin-top: 18px;
  }
  h2 {
    color: #27548c;
    font-size: 18px;
    font-weight: 500;
  }
`;

export const UserInfoCash = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  direction: rtl;
  margin-top: 52px;
  & > div {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 500;
    color: var(--text-500);
    justify-content: space-between;
    &:nth-of-type(1) {
      flex: 1.8;
      @media (max-width: 1540px) {
        flex: 2.5;
      }
      & span {
        flex: 2.5;
        display: inline-flex;
        margin-right: 8px;
        @media (max-width: 1440px) {
          margin-right: 10px;
        }
      }
      & img {
        width: 30px;
        height: 30px;
        @media (max-width: 1440px) {
          flex: 0;
        }
      }
    }
    &:nth-of-type(3) {
      flex: 2;
      @media (max-width: 1072px) {
        flex: 1.6;
      }
    }
    &.border {
      flex: 1.2;
      margin: 0 14px;
      border-bottom: 2px dotted var(--text-200);
      @media (max-width: 1700px) {
        flex: 1.4;
        margin: 0 12px;
      }
      @media (max-width: 1440px) {
        flex: 1;
        margin: 0 10px;
      }
      @media (max-width: 1300px) {
        flex: 0.7;
        margin: 0 8px;
      }
      @media (max-width: 1200px) {
        flex: 0;
        margin: 0 8px;
      }
    }
  }
  @media (max-width: 1775px) {
    & > div {
      font-size: 16px;
    }
  }
  @media (max-width: 1440px) {
    & > div {
      font-size: 14px;
    }
  }
`;

export const WalletPayContainer = styled.div`
  padding: 40px 60px 40px 60px;
  flex: 1.5;
  margin-left: 8px;
  direction: rtl;
  background: var(--bg-white);
  border: 1px solid var(--bg-gray);
  box-shadow: 2px 4px 10px rgba(108, 136, 170, 0.25);
  border-radius: 16px;
  height: 100%;
  & h2 {
    font-size: 18px;
    font-weight: 500;
    color: var(--primary-900);
    @media (max-width: 1024px) {
      font-size: 16px;
      font-weight: 400;
      color: var(--text-500);
    }
    @media (max-width: 600px) {
      font-size: 14px;
      font-weight: 500;
    }
    @media (max-width: 360px) {
      font-size: 12px;
      font-weight: 400;
    }
  }
  @media (max-width: 1875px) {
    padding: 40px 40px;
  }
  @media (max-width: 1536px) {
    padding: 40px 20px;
  }

  @media (max-width: 1024px) {
    flex: 1;
    width: 100%;
    margin-left: 0;
    padding: 0;
    background-color: transparent;
    box-shadow: none;
    border: none;
  }
`;

export const WalletFormContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 50px;
  @media (max-width: 1024px) {
    flex-direction: column;
    margin-top: 4px;
  }
`;
export const WalletForm = styled.form`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 4.6;
  margin-left: 130px;
  @media (max-width: 1440px) {
    margin-left: 100px;
  }
  @media (max-width: 1300px) {
    margin-left: 60px;
  }
  @media (max-width: 1024px) {
    margin-left: 0;
    flex: 1;
    margin-bottom: 24px;
    width: 100%;
  }
  input {
    display: inline-block;
    width: 100%;
    padding: 8px 8px;
    direction: rtl;
    outline: none;
    border: none;
    border: 1px solid var(--bg-gray);
    border-radius: 8px;
    padding: 0 10px;
    height: 48px;
    color: #2d3134;
    margin-left: 15px;
    -webkit-appearance: none;
  }
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type="number"] {
    -moz-appearance: textfield;
    appearance: textfield;
    margin: 0;
  }
  input::placeholder {
    font-size: 16px;
    font-weight: 500;
    color: #9cb0ca;
    @media (max-width: 1024px) {
      font-size: 14px;
    }
    @media (max-width: 360px) {
      font-size: 12px;
      font-weight: 700;
    }
  }
  /* @media (max-width: 1024px) {
    & input {
      width: 80%;
      &::placeholder {
        font-size: 14px;
      }
    }
  }
  @media (max-width: 480px) {
    & input {
      &::placeholder {
        font-size: 12px;
      }
    }
  } */
`;

export const WalletButtonContainer = styled.div`
  flex: 1.6;
  @media (max-width: 1024px) {
    flex: 1;
    width: 100%;
  }
  & button {
    width: 100%;
    outline: none;
    border-radius: 12px;
    /* padding: 10px 52px; */
    font-weight: 700;
    font-size: 16px;
    border: none;
    cursor: pointer;
    width: 160px;
    height: 48px;
    color: var(--bg-disable);
    background-color: var(--primary-400);
    &:hover {
      opacity: 0.7;
    }
    @media (max-width: 1440px) {
      width: 140px;
    }
    @media (max-width: 1200px) {
      width: 120px;
    }
    @media (max-width: 1024px) {
      width: 100%;
      height: 40px;
      font-size: 14px;
      font-weight: 500;
      color: var(--bg-white);
    }
  }
`;
export const Nodata = styled.div`
  display: flex;
  direction: rtl;
  justify-content: center;
  align-items: center;
  height: 100px;

  h4 {
    color: var(--primary-600);
  }
`;

export const ToggleTitleContainer = styled.div`
  border-bottom: 2px solid #e9ebf8;
  display: flex;
  gap: 24px;
  h2 {
    width: fit-content;
    padding-bottom: 10px;
    color: #9cb0ca;
  }
  .activeTitle {
    color: #27548c;
    border-bottom: 2px solid #6caeff;
  }
`;
